"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinleyCustomFunctionsPluginTranslations = exports.FinleyCustomFunctions = void 0;
const hyperformula_1 = require("hyperformula");
const luxon_1 = require("luxon");
const common_1 = require("@finley-technologies/common");
const isFuzzyMatch_1 = require("./isFuzzyMatch");
const linearStringArrayInterpolation_1 = require("./linearStringArrayInterpolation");
/**
 * Register Hyperformula custom functions
 * https://hyperformula.handsontable.com/guide/custom-functions.html
 *
 * in order to add a custom function, the function name must also be added to
 * the valid functions list {@link validFunctions} in packages/universal/formula-engine/source/validate.ts
 * otherwise it will fail to be recognized as a function
 */
class FinleyCustomFunctions extends hyperformula_1.FunctionPlugin {
    formatUsdCurrency(ast, state) {
        return this.runFunction(ast.args, state, this.metadata('USDOLLAR'), (amount) => {
            return `${common_1.utils.numberToCurrencyWithSymbol({
                number: amount,
            })}`;
        });
    }
    formatDate(ast, state) {
        return this.runFunction(ast.args, state, this.metadata('FORMATDATE'), (fullDateStr, dateFormat) => {
            // check if date format uses any unsupported tokens (time tokens)
            const validateDateFormat = common_1.date.validateLuxonDateFormatStringWithoutTime(dateFormat);
            if (!validateDateFormat.isValid) {
                return new hyperformula_1.CellError(hyperformula_1.ErrorType.VALUE, validateDateFormat.error);
            }
            const dateTimeObj = luxon_1.DateTime.fromISO(fullDateStr);
            const dateTimeString = dateTimeObj.toFormat(dateFormat);
            // check validity of a date with luxon method
            if (dateTimeObj.isValid) {
                return dateTimeString;
            }
            // if the string was not recognized as
            // a valid date return nothing
            return new hyperformula_1.CellError(hyperformula_1.ErrorType.VALUE, `Encountered invalid date [${fullDateStr}]`);
        });
    }
    fuzzyMatch(ast, state) {
        return this.runFunction(ast.args, state, this.metadata('FUZZYMATCH'), (strA, strB, maxEdits, swapChars) => {
            return (0, isFuzzyMatch_1.isFuzzyMatch)({ strA, strB, maxEdits, swapChars });
        });
    }
    linearStringArrayInterpolation(ast, state) {
        return this.runFunction(ast.args, state, this.metadata('LINEARSTRINGARRAYINTERPOLATION'), (interpolationInput, xValuesString, yValuesString) => {
            return (0, linearStringArrayInterpolation_1.linearStringArrayInterpolation)({
                interpolationInput,
                xValuesString,
                yValuesString,
            });
        });
    }
}
exports.FinleyCustomFunctions = FinleyCustomFunctions;
FinleyCustomFunctions.implementedFunctions = {
    USDOLLAR: {
        method: 'formatUsdCurrency',
        parameters: [{ argumentType: hyperformula_1.FunctionArgumentType.NUMBER }],
    },
    FORMATDATE: {
        method: 'formatDate',
        parameters: [
            { argumentType: hyperformula_1.FunctionArgumentType.STRING },
            { argumentType: hyperformula_1.FunctionArgumentType.STRING },
        ],
    },
    FUZZYMATCH: {
        method: 'fuzzyMatch',
        parameters: [
            { argumentType: hyperformula_1.FunctionArgumentType.STRING },
            { argumentType: hyperformula_1.FunctionArgumentType.STRING },
            { argumentType: hyperformula_1.FunctionArgumentType.NUMBER, minValue: 1 },
            { argumentType: hyperformula_1.FunctionArgumentType.STRING },
        ],
    },
    LINEARSTRINGARRAYINTERPOLATION: {
        method: 'linearStringArrayInterpolation',
        parameters: [
            { argumentType: hyperformula_1.FunctionArgumentType.NUMBER },
            { argumentType: hyperformula_1.FunctionArgumentType.STRING },
            { argumentType: hyperformula_1.FunctionArgumentType.STRING },
        ],
    },
};
exports.FinleyCustomFunctionsPluginTranslations = {
    enGB: {
        USDOLLAR: 'USDOLLAR',
        FORMATDATE: 'FORMATDATE',
        FUZZYMATCH: 'FUZZYMATCH',
        LINEARSTRINGARRAYINTERPOLATION: 'LINEARSTRINGARRAYINTERPOLATION',
    },
    enUS: {
        USDOLLAR: 'USDOLLAR',
        FORMATDATE: 'FORMATDATE',
        LINEARSTRINGARRAYINTERPOLATION: 'LINEARSTRINGARRAYINTERPOLATION',
    },
};
//# sourceMappingURL=customFunctions.js.map